<template>
  <!-- Checklist -->
  <div class="mb-10" v-if="hasCheckList">
    <h2 class="mb-4 text-xl font-semibold">Account setup checklist</h2>

    <div class="flex gro mr-2 mb-2" :class="{ 'line-through': item.done }" v-for="(item, i) in items" :key="i">
      <input
        type="checkbox"
        :checked="item.done"
        :disabled="item.done"
        class="w-6 h-6 text-brand-primary mb-2 bg-brand-light/10 rounded-[10px] p-3 appearance-none focus:outline-none border border-brand-light focus:border-brand-primary focus:border focus:ring-brand-primary"
      />
      <p class="ml-2 text-brand-black/70 text-lg whitespace-nowrap">{{ item.label }}</p>
    </div>

    <div class="mt-6">
      <Button
        data-test="login-button"
        label="Complete your profile"
        color="primary"
        type="button"
        class="px-3 rounded-xl"
        @click="$router.push('/profile')"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Button from '../Button.vue';

const store = useStore();

const items = computed(() => {
  const details = store.getters['auth/userDetails'];
  const { experiences, educations, job_preference, role_title, skills, projects } = details?.candidate;

  return [
    {
      label: 'Your profile information is incomplete',
      done: role_title ? true : false,
    },
    {
      label: 'You are yet to provide your previous work experience',
      done: experiences?.length ? true : false,
    },
    {
      label: 'Provide one or more educational qualification',
      done: educations.length ? true : false,
    },
    {
      label: 'Provide your top 5 most used skills',
      done: skills?.length ? true : false,
    },
    {
      label: 'Provide one or more recent projects you have worked on',
      done: projects?.length ? true : false,
    },
    {
      label: 'You have not updated your job preference details',
      done: job_preference?.company_categories.length ? true : false,
    },
    {
      label: 'You have not updated your preferred salary information',
      done: job_preference?.desired_salary && job_preference?.desired_salary_currencry ? true : false,
    },
  ];
});

const hasCheckList = computed(() => {
  if (!items.value.length) {
    return false;
  } else {
    const list = items.value.filter((item) => !item.done);
    return list.length ? true : false;
  }
});
</script>
